import React from 'react';
import { Modal } from 'antd';
import CustomButton from '../CustomButton';
import { DeleteAccount as deleteAccountAction } from '../../redux/actions/authAction';
import { useNavigate } from 'react-router-dom';



const DeleteAccountSection = ({ visible, onClose }) => {
  const navigate = useNavigate();
  const handleDelete = async () => {
    try {
      const organizationid = localStorage.getItem('organizationid');
      const payload = { organizationid };
    const res=   await deleteAccountAction(payload);
    if(res){
      onClose(); // Close modal on success
      navigate('/');
    }
    } catch (error) {
      console.error('Error deleting account:', error);
    }
  };

  return (
    <Modal
      className="deletemodal"
      title=""
      open={visible}
      onCancel={onClose}
      centered
      footer={null}
    >
      <h1>Delete Account?</h1>
      <p>Do you want to delete your account?</p>
      <div className="btn">
        <CustomButton onClick={handleDelete} text="Yes" />
        <CustomButton onClick={onClose} text="No" />
      </div>
    </Modal>
  );
};

export default DeleteAccountSection;
